module.exports = __webpack_public_path__ + "static/media/fulllogo_nobuffer.3cd05afe.jpg";